<template>
  <div class="main-wrapper blog">
    <user-header></user-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content blog-grid">
      <div class="container">
        <div class="row">
          <blog-sidebar></blog-sidebar>
          <div class="col-sm-12 col-md-8 col-lg-8">
            <div class="row">
              <div
                class="col-12 col-sm-12 col-md-12 col-lg-6"
                v-for="record in Blog_Grid_Sidebar"
                :key="record.id"
              >
                <!-- Blog -->
                <div class="featured-venues-item">
                  <div class="listing-item">
                    <div class="listing-img">
                      <router-link to="/blog/blog-details">
                        <img
                          :src="require(`@/assets/img/venues/${record.Image}`)"
                          class="img-fluid"
                          alt="Venue"
                        />
                      </router-link>
                      <div class="fav-item-venues news-sports">
                        <span class="tag tag-blue">{{ record.Sports }}</span>
                        <div class="list-reviews coche-star">
                          <a
                            href="javascript:void(0)"
                            class="fav-icon"
                            @click="toggleSelected(item)"
                          >
                            <i class="feather-heart"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="listing-content news-content">
                      <div class="listing-venue-owner">
                        <div class="navigation">
                          <a href="javascript:void(0)"
                            ><img
                              :src="require(`@/assets/img/profiles/${record.User}`)"
                              alt="User"
                            />{{ record.Name }}</a
                          >
                          <span><i class="feather-calendar"></i>{{ record.Date }}</span>
                        </div>
                      </div>
                      <h3 class="listing-title blog-title">
                        <router-link to="/blog/blog-details">{{ record.Title }} </router-link>
                      </h3>
                      <div class="listing-button read-new">
                        <ul class="nav">
                          <li>
                            <a href="javascript:void(0);"
                              ><i class="feather-heart"></i>{{ record.Like }}</a
                            >
                          </li>
                          <li>
                            <a href="javascript:void(0);"
                              ><i class="feather-message-square"></i
                              >{{ record.Comment }}</a
                            >
                          </li>
                        </ul>
                        <span
                          ><img
                            :src="require(`@/assets/img/icons/${record.Clock}`)"
                            alt="Icon"
                          />{{ record.LastSeen }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Blog -->
              </div>
            </div>
            <!--Pagination-->
            <div class="blog-pagination">
              <nav>
                <ul class="pagination justify-content-center pagination-center">
                  <li class="page-item previtem">
                    <a class="page-link" href="javascript:void(0);"
                      ><i class="feather-chevrons-left"></i
                    ></a>
                  </li>
                  <li class="page-item previtem">
                    <a class="page-link" href="javascript:void(0);"
                      ><i class="feather-chevron-left"></i
                    ></a>
                  </li>
                  <li class="page-item">
                    <a class="page-link active" href="javascript:void(0);">1</a>
                  </li>
                  <li class="page-item active">
                    <a class="page-link" href="javascript:void(0);">2</a>
                  </li>
                  <li class="page-item">
                    <a class="page-link" href="javascript:void(0);">3</a>
                  </li>
                  <li class="page-item nextlink">
                    <a class="page-link" href="javascript:void(0);">
                      <i class="feather-chevron-right"></i
                    ></a>
                  </li>
                  <li class="page-item nextlink">
                    <a class="page-link" href="javascript:void(0);">
                      <i class="feather-chevrons-right"></i
                    ></a>
                  </li>
                </ul>
              </nav>
            </div>
            <!--Pagination-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import Blog_Grid_Sidebar from "@/assets/json/blog-grid-sidebar.json";
export default {
  data() {
    return {
      Blog_Grid_Sidebar: Blog_Grid_Sidebar,
      title: "Blog Grid Sidebar",
      text: "Home",
      text1: "Blog Grid Sidebar",
    };
  },
  methods: {
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
  },
};
</script>
